<template>
  <div class="chat-bubble">
    <v-menu v-model="show" top left :close-on-content-click="false" :nudge-width="250" offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn dark fab @click="updateCount()" :color="hasUnreadClass()" v-on="on" v-bind="attrs">
          <v-icon dark >{{ icon() }}</v-icon>
        </v-btn>
      </template>

      <v-card max-width="600px">
        <v-card-text class="chat-text" ref="chat">
          <v-list>
            <v-list-item v-for="msg, idx in messages" :key="idx">

              <!-- others -->
              <v-list-item-content v-if="msg.name !== name">
                <v-list-item-title>
                  <v-chip label small>{{ getTime(msg.ts) }}</v-chip>
                  <strong v-if="msg.name" class="ml-2"> {{ msg.name }}</strong>
                  <v-chip v-else color="primary darken-1" label class="ml-2">System</v-chip>
                </v-list-item-title>

                <v-list-item-subtitle style="white-space: normal">
                  {{ msg.text }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <!-- us -->
              <v-list-item-content v-else>
                <v-list-item-title class="d-flex">
                  <v-spacer></v-spacer>
                  <strong class="mr-2"> {{ msg.name }}</strong>
                  <v-chip label small>{{ getTime(msg.ts) }}</v-chip>
                </v-list-item-title>

                <v-list-item-subtitle style="white-space: normal" class="d-flex">
                  <v-spacer></v-spacer>
                  <span>{{ msg.text }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-card-text>
        <v-card-actions>

          <v-text-field
            dense
            outlined
            hide-details
            :label="textEntryLabel"
            v-model="text"
            @input="parseText"
            @keydown.enter="sendText"
            :disabled="isMuted || someoneElseTyping"
          ></v-text-field>
          <!-- v-btn icon><v-icon @click="show = false">mdi-close</v-icon></v-btn -->
        </v-card-actions>
      </v-card>

    </v-menu>

    <v-dialog max-width="600px" v-model="askSendSure">
      <v-card>
        <v-card-title>
          Warning!
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex justify-center align-center">
              <span>Warning! <strong>{{ sentBy }}</strong> just sent a message on this account:
                <strong>{{ sentMessage }}</strong></span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="d-flex justify-center align-center">
              <span>Do you still want to send your message?</span>
            </v-col>
            <v-col cols="12" class="d-flex justify-center align-center">
              <span><strong class="text-h6">{{ sentOriginalMessage }}</strong></span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>

          <v-btn text @click="askSendSure = false">No</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="orange" @click="text=sentOriginalMessage; sendText(true); askSendSure = false">
            <v-icon class="mr-2" color="red">mdi-alert</v-icon>
            Yes
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import bus from '@/bus.js';
import { mapGetters } from 'vuex';

export default {
  props: {
    name: String
  },

  sockets: {
    chat_is_busy(data) {
      this.sentBy = data.sent_by ? data.sent_by.user : null;
      this.sentMessage = data.sent_message;
      this.sentOriginalMessage = data.message;

      this.askSendSure = true;
    }
  },

  computed: {
    textEntryLabel() {
      if (this.someoneElseTyping) {
        return `${this.chatAcc.is_typing.user} is currently typing...`;
      }

      if (this.isMuted) {
        return 'Can\'t chat, chat is restricted';
      }

      return 'send text';
    },

    messages() {
      return this.messagesForUser(this.name).filter((msg) => {
        if (msg.type === 'warning') {
          return this.shouldShowWarningMsg(msg);
        }

        return Boolean(msg.name)
      });
    },
    isMuted() {
      if (!this.state) return false;
      if (!("room" in this.state)) return false;
      if (!("settings" in this.state.room)) return false;

      if (!this.isSitting && this.state.room.settings.viewerMute) return true;
      if (this.isSitting && this.state.room.settings.playerMute) return true;

      return false;
    },
    chatAcc() {
      return this.chatAccountByKey(this.name);
    },
    clubAccount() {
      return this.clubmgmAccountByName(this.name);
    },
    club() {
      return (this.clubAccount || {}).club || {};
    },
    app() {
      if (!this.club) return 'Pkr2';
      if (!this.club.app) return 'Pkr2';
      return this.club.app;
    },

    someoneElseTyping() {
      if (!this.chatAcc) return false;
      if (!this.chatAcc.is_typing) return false;
      if (this.chatAcc.is_typing._id === this.activeOperatorId) return false;
      let nowTs = new Date().getTime() / 1000;
      if (this.chatAcc.is_typing.ts < nowTs - 10) return false;
      return true;
    },

    state() {
      return this.accountState(this.name);
    },
    isSitting() {
      let p = this.ourPlayer(this.name);

      if (!p) return false;

      if (p.seat === 0) return true;

      if (p.seat && p.seat >= 0) return true;

      return false;
    },
    ...mapGetters([
      'messagesForUser',
      'ourPlayer',
      'accountState',
      'isAdmin',
      'isDev',
      'isClaud',
      'isAlex',
      'isPedro',
      'activeOperatorId',
      'clubmgmAccountByName',
      'chatAccountByKey',
    ])
  },
  data() {
    return {
      count: 0,
      color: 'cyan',
      show: false,
      len: 0,
      text: '',

      isTyping: false,
      isTypingTimeout: null,

      askSendSure: false,
      sentBy: null,
      sentMessage: null,
      sentOriginalMessage: null
    };
  },
  methods: {
    parseText() {
      if (!this.isTyping) {
        this.$socket.emit("start_typing", {'displayID': this.name});
      }

      if (this.app != 'ClubGG') {
        let text = this.text;

        // capitalize first letter
        text = this.text.charAt(0).toUpperCase() + this.text.substr(1, this.text.length);

        // capitalize i
        text = text.replaceAll(" i ", " I ");
        // capitalize i'm
        text = text.replaceAll(" i'm ", " I'm ");
        // im to I'm
        text = text.replaceAll(" im ", " I'm ");
        if (text.startsWith("Im ")) {
          text = text.replace("Im ", "I'm ");
        }

        // capitalize after punctuation
        let re = /(^|[.!?]\s+)([a-z])/g;
        text = text.replace(re, (m, $1, $2) => $1 + $2.toUpperCase());

        this.text = text;
      }

      this.isTyping = true;

      // reset timeout
      clearTimeout(this.isTypingTimeout);
      this.isTypingTimeout = setTimeout(() => {
        this.isTyping = false;
        this.$socket.emit("stop_typing", {'displayID': this.name});
      }, 10000)
    },

    hasUnreadClass() {
      var cls = 'light-blue';
      if (this.count < this.messages.length) {
        cls = 'pink';
      }
      return cls;
    },

    icon() {
      if (this.count < this.messages.length) {
        return 'mdi-chat-alert';
      }
      return 'mdi-chat';
    },

    updateCount() {
      this.count = this.messages.length;
      let chat = this.$refs.chat;
      if (chat) {
        chat.scrollTop = chat.scrollHeight;
      }
    },

    getTime(ts) {
       var time = ts.toLocaleTimeString();
       var parts = time.split(" ")[0].split(':');
       return parts[0] + ":" + parts[1];
    },

    sendText(forceSend=false) {
      // ignore empty text
      if (!this.text.trim().length) return;

      let payload = {
        'displayID': this.name,
        'text': this.text
      }

      if (forceSend === true) {
        payload.send_anyway = true;
      }

      // send msg
      this.$socket.emit("send_chat", payload);
      this.text = '';

      // update typing
      this.isTyping = false;
      this.$socket.emit("stop_typing", {'displayID': this.name});
      clearTimeout(this.isTypingTimeout);
    },

    isDebugWarningMsg(message) {
      if (message.is_debug) {
        return true;
      }

      if (message.text.indexOf("Error:") >= 0) {
        // some errors shouldn't be shown
        if (message.text.indexOf("dummyForNotShowMessageOnUI") >= 0) {
          return true;
        }

        if (message.text.indexOf("NOT_IN_ROOM") >= 0) {
          return true;
        }
      }

      if (message.text.indexOf("(debug)") >= 0) {
        return true;
      }

      return false;
    },

    shouldShowWarningMsg(message) {
      if (message.dev_only) {
        return this.isDev;
      }

      if (this.isDebugWarningMsg(message)) {
        // only claud&alex&pedro sees debug messages
        return this.isClaud || this.isAlex || this.isPedro;
      }

      // if not debug, everyone sees all
      return true;
    },
  }
}
</script>

<style scoped>
.chat-bubble {
  display: flex;
  position: absolute;
  top: 600px;
  left: 350px;
  width: 500px;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-panel {
  height: 440px;
  max-height: 440px;
}

.chat-text {
  height: 320px;
  overflow-y: scroll;
  overflow-x: auto;
}
</style>
